import { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';

import facebook from '../../assets/images/Footer/icon/facebook.png';
import zalo from '../../assets/images/Footer/icon/zalo.png';
import youtube from '../../assets/images/Footer/icon/youtube.jpg';
import instagram from '../../assets/images/Footer/icon/instagram.png';
import tiktok from '../../assets/images/Footer/icon/tiktok.png';
import QrCodeZalopage from '../../assets/images/Footer/Qr-code-Zalopage-Aptech.jpg';

import './Footer.css';
import Title from '../shared/Title';
function Footer() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMap, setModalMap] = useState(false);
  const [year, setYear] = useState(false);

  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);

  const contentStyleZalo = {
    maxWidth: '1024px',
    width: 'fit-content',
    height: '95vh',
  };

  const contentStyleMap = {
    maxWidth: '1024px',
    minWidth: '300px',
    width: 'fit-content',
    height: 'fit-content',
  };

  return (
    <>
      <div className="relative bg-cover w-full h-[1000px] md:h-[1100px] 2xl:h-[1250px] footer__background">
        <div className="w-full absolute bottom-0">
          <div className="mt-5">
            <div className="flex justify-center">
              <p className="footer__icon">
                <a href="https://www.facebook.com/CUSC.CE/" target="_blank">
                  <img src={facebook} />
                </a>
              </p>
              <p className="footer__icon">
                <a
                  onClick={() => {
                    setModalOpen(true);
                  }}
                  target="_blank"
                >
                  <img src={zalo} />
                </a>
              </p>

              <div className="footer__icon">
                <a href="https://www.youtube.com/c/CUSCAPTECHCHANNEL" target="_blank">
                  <img src={youtube} />
                </a>
              </div>

              <div className="footer__icon">
                <a href="https://www.instagram.com/arena.cantho/" target="_blank">
                  <img src={instagram} />
                </a>
              </div>

              <div className="footer__icon">
                <a href="https://www.tiktok.com/@cusc.computer.edu" target="_blank">
                  <img src={tiktok} />
                </a>
              </div>


            </div>
          </div>
          <div className="mt-5 px-10 md:px-5">
            <Title className="footer-text text-center font-bold uppercase mb-8 mt-10">
              <p>TRUNG TÂM CÔNG NGHỆ PHẦN MỀM ĐẠI HỌC CẦN THƠ</p>
            </Title>
            <a
              onClick={() => {
                setModalMap(true);
              }}
              className="footer-text text-center font-bold text-base my-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 mr-2 inline-block -translate-y-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <p>Khu III,</p>
              <p>&nbsp;Đại học Cần Thơ,</p>
              <p>&nbsp;01 Lý Tự Trọng,</p>
              <p>&nbsp;P. Ninh Kiều, TP. Cần Thơ</p>
            </a>

            <div className="flex justify-center text-center font-bold text-base my-2">
              <div className="mr-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>
              Email:
              <a className="ml-1" href="mailto:tuyensinh@cusc.ctu.edu.vn?subject=Tuyển sinh">
                tuyensinh@cusc.ctu.edu.vn
              </a>
            </div>

            <div className="flex justify-center text-center font-bold text-base my-2">
              <div className="mr-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
              </div>
              Hotline:
              <a className="ml-1" href="tel:+842923835581">
                02923835581
              </a>
            </div>

            <div className="flex justify-center text-center font-bold text-base my-2">
              <div className="mr-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
              </div>
              Điện thoại:
              <a className="ml-1" href="tel:">
                0329474679 , 0328788186, 0862426266 , 0868952545, 0868952535
              </a>
            </div>

            <div className="flex justify-center text-center font-bold text-base my-2">
              <div className="mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="24px" height="24px"><path d="M 9 4 C 6.2504839 4 4 6.2504839 4 9 L 4 41 C 4 43.749516 6.2504839 46 9 46 L 41 46 C 43.749516 46 46 43.749516 46 41 L 46 9 C 46 6.2504839 43.749516 4 41 4 L 9 4 z M 9 6 L 15.580078 6 C 12.00899 9.7156859 10 14.518083 10 19.5 C 10 24.66 12.110156 29.599844 15.910156 33.339844 C 16.030156 33.549844 16.129922 34.579531 15.669922 35.769531 C 15.379922 36.519531 14.799687 37.499141 13.679688 37.869141 C 13.249688 38.009141 12.97 38.430859 13 38.880859 C 13.03 39.330859 13.360781 39.710781 13.800781 39.800781 C 16.670781 40.370781 18.529297 39.510078 20.029297 38.830078 C 21.379297 38.210078 22.270625 37.789609 23.640625 38.349609 C 26.440625 39.439609 29.42 40 32.5 40 C 36.593685 40 40.531459 39.000731 44 37.113281 L 44 41 C 44 42.668484 42.668484 44 41 44 L 9 44 C 7.3315161 44 6 42.668484 6 41 L 6 9 C 6 7.3315161 7.3315161 6 9 6 z M 33 15 C 33.55 15 34 15.45 34 16 L 34 25 C 34 25.55 33.55 26 33 26 C 32.45 26 32 25.55 32 25 L 32 16 C 32 15.45 32.45 15 33 15 z M 18 16 L 23 16 C 23.36 16 23.700859 16.199531 23.880859 16.519531 C 24.050859 16.829531 24.039609 17.219297 23.849609 17.529297 L 19.800781 24 L 23 24 C 23.55 24 24 24.45 24 25 C 24 25.55 23.55 26 23 26 L 18 26 C 17.64 26 17.299141 25.800469 17.119141 25.480469 C 16.949141 25.170469 16.960391 24.780703 17.150391 24.470703 L 21.199219 18 L 18 18 C 17.45 18 17 17.55 17 17 C 17 16.45 17.45 16 18 16 z M 27.5 19 C 28.11 19 28.679453 19.169219 29.189453 19.449219 C 29.369453 19.189219 29.65 19 30 19 C 30.55 19 31 19.45 31 20 L 31 25 C 31 25.55 30.55 26 30 26 C 29.65 26 29.369453 25.810781 29.189453 25.550781 C 28.679453 25.830781 28.11 26 27.5 26 C 25.57 26 24 24.43 24 22.5 C 24 20.57 25.57 19 27.5 19 z M 38.5 19 C 40.43 19 42 20.57 42 22.5 C 42 24.43 40.43 26 38.5 26 C 36.57 26 35 24.43 35 22.5 C 35 20.57 36.57 19 38.5 19 z M 27.5 21 C 27.39625 21 27.29502 21.011309 27.197266 21.03125 C 27.001758 21.071133 26.819727 21.148164 26.660156 21.255859 C 26.500586 21.363555 26.363555 21.500586 26.255859 21.660156 C 26.148164 21.819727 26.071133 22.001758 26.03125 22.197266 C 26.011309 22.29502 26 22.39625 26 22.5 C 26 22.60375 26.011309 22.70498 26.03125 22.802734 C 26.051191 22.900488 26.079297 22.994219 26.117188 23.083984 C 26.155078 23.17375 26.202012 23.260059 26.255859 23.339844 C 26.309707 23.419629 26.371641 23.492734 26.439453 23.560547 C 26.507266 23.628359 26.580371 23.690293 26.660156 23.744141 C 26.819727 23.851836 27.001758 23.928867 27.197266 23.96875 C 27.29502 23.988691 27.39625 24 27.5 24 C 27.60375 24 27.70498 23.988691 27.802734 23.96875 C 28.487012 23.82916 29 23.22625 29 22.5 C 29 21.67 28.33 21 27.5 21 z M 38.5 21 C 38.39625 21 38.29502 21.011309 38.197266 21.03125 C 38.099512 21.051191 38.005781 21.079297 37.916016 21.117188 C 37.82625 21.155078 37.739941 21.202012 37.660156 21.255859 C 37.580371 21.309707 37.507266 21.371641 37.439453 21.439453 C 37.303828 21.575078 37.192969 21.736484 37.117188 21.916016 C 37.079297 22.005781 37.051191 22.099512 37.03125 22.197266 C 37.011309 22.29502 37 22.39625 37 22.5 C 37 22.60375 37.011309 22.70498 37.03125 22.802734 C 37.051191 22.900488 37.079297 22.994219 37.117188 23.083984 C 37.155078 23.17375 37.202012 23.260059 37.255859 23.339844 C 37.309707 23.419629 37.371641 23.492734 37.439453 23.560547 C 37.507266 23.628359 37.580371 23.690293 37.660156 23.744141 C 37.739941 23.797988 37.82625 23.844922 37.916016 23.882812 C 38.005781 23.920703 38.099512 23.948809 38.197266 23.96875 C 38.29502 23.988691 38.39625 24 38.5 24 C 38.60375 24 38.70498 23.988691 38.802734 23.96875 C 39.487012 23.82916 40 23.22625 40 22.5 C 40 21.67 39.33 21 38.5 21 z" /></svg>
              </div>
              Zalo:
              <a className="ml-1" href="tel:+842923835581">
                0868952545 (CUSC - ARENA)
              </a>
            </div>
              
              {/* Facebook */}
            {/* <div className="flex justify-center text-center font-bold text-base my-2">
              <div className="mr-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  fill="black"
                >
                  <path d="M13.5 9H16V6h-2.5C10.46 6 9 7.58 9 10.09V12H7v3h2v9h3v-9h2.5l.5-3H12v-1.6c0-.9.23-1.4 1.5-1.4z" />
                </svg>
              </div>
              <a className="ml-1" href="https://www.facebook.com/CUSC.CE">
                CUSC Computer Education
              </a>
            </div> */}

              {/* Tiktok */}
            {/* <div className="flex justify-center text-center font-bold text-base my-2">
              <div className="mr-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 96 96"
                  fill="black"
                >
                  <rect
                    width="96"
                    height="96"
                    rx="21"
                    fill="black"
                  />

                  <path
                    d="M73.31 25.7456C72.785 25.4743 72.274 25.1769 71.7788 24.8545C70.3389 23.9025 69.0186 22.7808 67.8465 21.5135C64.9139 18.158 63.8186 14.7538 63.4151 12.3705H63.4313C63.0943 10.3921 63.2337 9.11214 63.2547 9.11214H49.8974V60.7624C49.8974 61.4558 49.8974 62.1412 49.8682 62.8185C49.8682 62.9027 49.8601 62.9805 49.8553 63.0712C49.8553 63.1085 49.8553 63.1474 49.8472 63.1863C49.8472 63.196 49.8472 63.2057 49.8472 63.2154C49.7064 65.0686 49.1123 66.8588 48.1173 68.4286C47.1222 69.9983 45.7566 71.2994 44.1407 72.2175C42.4565 73.1757 40.5517 73.6782 38.614 73.6757C32.3906 73.6757 27.3468 68.6011 27.3468 62.334C27.3468 56.0669 32.3906 50.9923 38.614 50.9923C39.7921 50.9912 40.9629 51.1766 42.083 51.5415L42.0992 37.9412C38.6989 37.502 35.2444 37.7722 31.9538 38.7348C28.6631 39.6975 25.6077 41.3317 22.9802 43.5343C20.678 45.5346 18.7425 47.9214 17.2608 50.5872C16.6969 51.5594 14.5695 55.4658 14.3119 61.8058C14.1499 65.4044 15.2306 69.1326 15.7458 70.6734V70.7058C16.0699 71.6132 17.3256 74.7094 19.372 77.3197C21.0221 79.4135 22.9716 81.2527 25.1579 82.7783V82.7459L25.1903 82.7783C31.6567 87.1724 38.8263 86.884 38.8263 86.884C40.0674 86.8338 44.2249 86.884 48.9463 84.6464C54.183 82.1658 57.1642 78.47 57.1642 78.47C59.0688 76.2618 60.5832 73.7452 61.6426 71.0282C62.8513 67.8509 63.2547 64.0401 63.2547 62.5171V35.1155C63.4168 35.2127 65.5749 36.6401 65.5749 36.6401C65.5749 36.6401 68.6842 38.633 73.5352 39.9309C77.0155 40.8544 81.7045 41.0488 81.7045 41.0488V27.7887C80.0615 27.9669 76.7255 27.4485 73.31 25.7456Z"
                    fill="white"
                  />
                </svg>

              </div>
              <a className="ml-1" href="https://www.tiktok.com/@cusc.computer.edu">
                CUSC Computer Education
              </a>
            </div> */}

          </div>
          <div className="mt-5 flex p-2 bg-black text-white">
            <p className="uppercase m-auto">ARENA MULTIMEDIA - CUSC © {year}</p>
          </div>
        </div>
      </div>

      <Popup contentStyle={contentStyleZalo} open={modalOpen} closeOnDocumentClick onClose={() => setModalOpen(false)}>
        <div className="modal bg-white h-full relative shadow-2xl rounded-[25px]">
          {/* Title */}
          <div className="p-4 text-sm md:text-lg font-bold uppercase text-center shadow-[0px_0px_12px_rgba(0,0,0,0.1)] rounded-[25px] flex flex-row-reverse">
            <span
              className="close text-4xl hover:scale-[1.1] cursor-pointer text-red-600 float-right -translate-y-1 font-bold right-0 mx-2"
              onClick={() => setModalOpen(false)}
            >
              &times;
            </span>
            <span class="text-center grow"> Zalo offical</span>
          </div>
          {/* Content */}
          <div className="content h-full pb-8 px-2.5 relative">
            <div className="mt-4  md:mx-10 overflow-auto no-scrollbar h-full relative">
              <img className="relative h-[80%] left-[50%] translate-x-[-50%]" src={QrCodeZalopage} />
            </div>
          </div>
        </div>
      </Popup>

      <Popup contentStyle={contentStyleMap} open={modalMap} closeOnDocumentClick onClose={() => setModalMap(false)}>
        <div className="modal bg-white h-full relative shadow-2xl rounded-[25px]">
          {/* Title */}
          <div className="p-4 text-sm md:text-lg font-bold uppercase text-center shadow-[0px_0px_12px_rgba(0,0,0,0.1)] rounded-[25px] flex flex-row-reverse">
            <span
              className="close text-4xl hover:scale-[1.1] cursor-pointer text-red-600 float-right -translate-y-1 font-bold right-0 mx-2"
              onClick={() => setModalMap(false)}
            >
              &times;
            </span>
            <span class="text-center grow">Khu III, ĐH Cần Thơ, 01 Lý Tự Trọng, Q. Ninh Kiều, TP. Cần Thơ</span>
          </div>
          {/* Content */}
          <div className="content h-full pb-8 px-2.5 relative">
            <div className="mt-4  md:mx-10 overflow-auto no-scrollbar h-full relative">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3928.793338384504!2d105.77768491428219!3d10.033905575203882!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31a0881f9a732075%3A0xfa43fbeb2b00ca73!2sCUSC%20-%20Cantho%20University%20Software%20Center!5e0!3m2!1svi!2sus!4v1663337506772!5m2!1svi!2sus"
                width="600"
                height="450"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </Popup>
    </>
  );
}

export default Footer;
